import LegalPage from "../Components/LegalPage.js";

export function TermsOfSale() {
  return <LegalPage bodyKey="legal.tosale.body" />;
}
